import React from 'react';
import { Skeleton } from '../ui/skeleton';

export const ProductGridSkeleton = ({ count = 8 }) => (
  <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="bg-card rounded-xl overflow-hidden shadow-card">
        <Skeleton className="aspect-square" />
        <div className="p-4 space-y-3">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-5 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <div className="flex gap-2 pt-2">
            <Skeleton className="h-9 flex-1" />
            <Skeleton className="h-9 flex-1" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const PageSkeleton = () => (
  <div className="max-w-7xl mx-auto px-4 py-12 space-y-8">
    <Skeleton className="h-8 w-64" />
    <Skeleton className="h-4 w-96" />
    <ProductGridSkeleton />
  </div>
);
